export default [
  {
    path: "/ReceiptOperation/Trustaccountsetting",
    name: "Trustaccountsetting",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/Trustaccountsetting/Trustaccountsetting.vue"
      ),
    props: true,

    meta: {
      pageTitle: "信託專戶設定",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/addreceive",
    name: "addreceive",
    component: () =>
      import("@/views/pages/ReceiptOperation/addreceive/addreceive.vue"),
    props: true,

    meta: {
      pageTitle: "新增收出款項",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/aptoapreceive",
    name: "aptoapreceive",
    component: () =>
      import("@/views/pages/ReceiptOperation/aptoapreceive/aptoapreceive.vue"),
    props: true,

    meta: {
      pageTitle: "APTOAP收款維護",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/editreceive",
    name: "editreceive",
    component: () =>
      import("@/views/pages/ReceiptOperation/editreceive/editreceive.vue"),
    props: true,

    meta: {
      pageTitle: "收出款修改維護",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/reviewreceive",
    name: "reviewreceive",
    component: () =>
      import("@/views/pages/ReceiptOperation/reviewreceive/reviewreceive.vue"),
    props: true,

    meta: {
      pageTitle: "收款審核維護",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/summonsreceive",
    name: "summonsreceive",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/summonsreceive/summonsreceive.vue"
      ),
    props: true,

    meta: {
      pageTitle: "收款傳票維護",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/applyreceive",
    name: "applyreceive",
    component: () =>
      import("@/views/pages/ReceiptOperation/applyreceive/applyreceive.vue"),
    props: true,

    meta: {
      pageTitle: "出款申請書維護",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/accountfundstable",
    name: "Trusteditfunds",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/accountfundstable/accountfundstable.vue"
      ),
    props: true,

    meta: {
      pageTitle: "專戶控管資金表(信託)",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/checkreceive",
    name: "checkreceive",
    component: () =>
      import("@/views/pages/ReceiptOperation/checkreceive/checkreceive.vue"),
    props: true,

    meta: {
      pageTitle: "出款確認維護",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/reissuenewsletter",
    name: "reissuenewsletter",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/reissuenewsletter/reissuenewsletter.vue"
      ),
    props: true,

    meta: {
      pageTitle: "簡訊重補發作業",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/agreementreceive",
    name: "agreementreceive",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/agreementreceive/agreementreceive.vue"
      ),
    props: true,

    meta: {
      pageTitle: "協議動用出款確認",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/interesttable",
    name: "Trustinteresttable",
    component: () =>
      import("@/views/pages/ReceiptOperation/interesttable/interesttable.vue"),
    props: true,

    meta: {
      pageTitle: "利息差異表",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/checkmessage",
    name: "TrustAPTOAP",
    component: () =>
      import("@/views/pages/ReceiptOperation/checkmessage/checkmessage.vue"),
    props: true,

    meta: {
      pageTitle: "支票簡訊檔",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/guaranteefee",
    name: "Trustguaranteefee",
    component: () =>
      import("@/views/pages/ReceiptOperation/guaranteefee/guaranteefee.vue"),
    props: true,

    meta: {
      pageTitle: "履保費用明細表",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/instructionswork",
    name: "Trustinstructions",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/instructionswork/instructionswork.vue"
      ),
    props: true,

    meta: {
      pageTitle: "指示書作業",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/receivestatussearch",
    name: "Truststatusfunds",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/receivestatussearch/receivestatussearch.vue"
      ),
    props: true,

    meta: {
      pageTitle: "出款狀態查詢",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/instructionsback",
    name: "Trustrefund",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/instructionsback/instructionsback.vue"
      ),
    props: true,

    meta: {
      pageTitle: "撤/退票指示書",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/retransferwork",
    name: "Trustretransfer",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/retransferwork/retransferwork.vue"
      ),
    props: true,

    meta: {
      pageTitle: "退匯重匯作業",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/receivestatusupload",
    name: "Truststatusupdate",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/receivestatusupload/receivestatusupload.vue"
      ),
    props: true,

    meta: {
      pageTitle: "出款狀態手動上傳",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReceiptOperation/accountdaytable",
    name: "Trustaccountbalance",
    component: () =>
      import(
        "@/views/pages/ReceiptOperation/accountdaytable/accountdaytable.vue"
      ),
    props: true,

    meta: {
      pageTitle: "專戶餘額日報表",
      breadcrumb: [
        {
          text: "收出款作業",
          active: true,
        },
      ],
    },
  },
];
